import { watch } from 'vue';
import MixpanelPluginV2 from '@satellite/plugins/MixpanelPluginV2.js';
import type { AnalyticsClient } from '@satellite/composables/useAnalytics';

import config from '@/config';
import { useAnalytics } from '@satellite/composables/useAnalytics';
import { useWarehouseInfo } from './useWarehouseInfo';

export function createJunoAnalyticsClient(): AnalyticsClient {
  const mixpanel = new MixpanelPluginV2({
    token: config.mixpanel_token ?? null,
    enabled: Boolean(config.mixpanel_token),
    debug: config.server_env === 'development'
  });
  mixpanel.init();

  return {
    track: (event, payload) => mixpanel.track(String(event), payload),
    identify: value => {
      if (typeof value !== 'string' || !value) {
        return;
      }
      mixpanel.identify(value);
    },
    reset: () => mixpanel.reset(),
    registerSuper: props => mixpanel.setProperties(props),
    setUserProperties: props => mixpanel.setUserProperties(props)
  };
}

export function useJunoAnalytics() {
  const analytics = useAnalytics();
  const { warehouseData } = useWarehouseInfo();

  watch(
    warehouseData,
    warehouse => {
      if (!warehouse) return;
      analytics.registerSuper({
        warehouse_id: warehouse.id ?? null,
        warehouse_name: warehouse.name ?? null,
        org_id: warehouse.org?.id ?? null,
        org_name: warehouse.org?.name ?? null
      });
    },
    { immediate: true }
  );
}
